import { formatServerDate, moscowShortDate, parseServerDate } from '../../domain/moscowTime';
import { lastAllowedDay } from '../../domain/schedule';
import f from '../pass-form/passForm.module.css';

interface Props {
  /** Picked last day ("Y-m-d"), or '' for the default window. */
  value: string;
  onChange: (day: string) => void;
  startsAt: Date | null;
  expiresAt: Date | null;
  limitHours: number | null;
}

/** «По какое число» of a temporary pass: the last day, bounded by the start and the object limit. */
export function UntilField({ value, onChange, startsAt, expiresAt, limitHours }: Props) {
  const min = startsAt ? formatServerDate(startsAt).slice(0, 10) : undefined;
  const max = lastAllowedDay(startsAt, limitHours) ?? undefined;
  const shown = value || (expiresAt ? formatServerDate(expiresAt).slice(0, 10) : '');
  return (
    <div className={f.field}>
      <label htmlFor="until" className={f.label}>
        По какое число
      </label>
      <input id="until" type="date" className={f.input} value={shown} min={min} max={max} onChange={(e) => onChange(e.target.value)} />
      {max && <span className={f.hint}>Не позже {moscowShortDate(parseServerDate(`${max} 12:00:00`)!)} — так настроено на объекте</span>}
    </div>
  );
}
